import {
  DateType,
  EPriceTime,
  getMarkAreaData,
  momTitleFunc,
  formatNumber,
  icons,
  WorkStatusType,
  WorkStatusDisplay,
  xLabel,
} from '../../utils';
import dayjs from 'dayjs';
import { Themes } from '@maxtropy/components';
import { DataProps, StateEnergyProps } from '..';
import { keepOneOrLine, keepTwoOrLine } from '@/utils/utils';

type PeriodKey = 'summitDataList' | 'peakDataList' | 'plainDataList' | 'valleyDataList' | 'totalDataList';
type BubbleDataType = StateEnergyProps['bubble'];

// 状态映射：type -> 颜色 & 文本
const statusMap = {
  [WorkStatusType.RUN]: { name: '运行用能', color: 'rgba(22,221,142,0.8)' },
  [WorkStatusType.SHUT]: { name: '停机用能', color: 'rgba(255,77,79,0.8)' },
  [WorkStatusType.STANDBY]: { name: '待机用能', color: 'rgba(250,173,20,0.8)' },
};

export const getChartOption = (
  datas: DataProps,
  stateEnergyData: StateEnergyProps,
  timeResolution: string,
  ePriceTimes: EPriceTime[],
  theme: Themes
) => {
  // 分别计算 totalData 和 periodData 的统计值
  const unit = datas.generalUnitName;
  const statsA = getStats(datas?.totalData);
  const statsC = getUnstackedStats(datas?.totalData);

  const isShowYoy = timeResolution === DateType.WEEK || timeResolution === DateType.MONTH;
  const bubbleData = stateEnergyData.bubble;
  // const xData = datas?.totalData?.peakDataList?.map(i => i.time) || [];

  return {
    grid: [
      {
        left: 40,
        right: 40,
        top: 70,
        containLabel: true,
        height: timeResolution === DateType.DAY ? '65%' : '75%',
      },
    ],
    // legend: { show: 'true' },
    legend: [
      {
        right: 170,
        top: 6,
        icon: 'rect',
        itemWidth: 12,
        itemHeight: 12,
        data: [
          { name: '尖时段' },
          { name: '峰时段' },
          { name: '平时段' },
          { name: '谷时段' },
          { name: `${datas.dataQueryPeriodName} - 尖时段` },
          { name: `${datas.dataQueryPeriodName} - 峰时段` },
          { name: `${datas.dataQueryPeriodName} - 平时段` },
          { name: `${datas.dataQueryPeriodName} - 谷时段` },
        ],
      },
      {
        right: 80,
        top: 6,
        icon: 'rect',
        itemWidth: 12,
        itemHeight: 4,
        data: [{ name: '总用能成本' }],
      },
    ],
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow',
      },
      formatter: function (originParams: any) {
        // 检查每个组在该时间点是否有数据
        let toolHtmlDay = ``;
        let tooltipHtml = ``;
        let toolBubble = ``;
        const cost = originParams.find((item: any) => item.seriesName === '总用能成本');
        const params = originParams.filter((item: any) => item.seriesName !== '总用能成本');

        const dataIndex = params[0]?.dataIndex;
        if (dataIndex === undefined || dataIndex === null) {
          return;
        }
        const item = datas.totalData?.totalDataList?.[dataIndex];
        const periodItem = datas.periodData?.totalDataList?.[dataIndex];
        const factData = WorkStatusDisplay[params[0].data.type as WorkStatusType];
        const factcolor =
          params[0].data.type === WorkStatusType.SHUT
            ? 'rgba(255,77,79,0.8)'
            : params[0].data.type === WorkStatusType.RUN
            ? 'rgba(22,221,142,0.8)'
            : params[0].data.type === WorkStatusType.STANDBY
            ? 'rgba(250,173,20,0.8)'
            : 'none';

        toolHtmlDay += `
          <div style="font-size:12px;">
          <table>
              <tr style="text-align: right;">
                <td style="padding: 0 8px; text-align: left">
                ${dayjs(Number(params[0]?.axisValue)).format(
                  timeResolution === DateType.DAY ? 'YYYY-MM-DD HH:mm' : xLabel(timeResolution)
                )}</td>
                <td style="padding: 0 8px">用能</td>
                <td style="padding: 0 8px">${momTitleFunc(timeResolution as DateType)}</td>
                ${isShowYoy ? `<td style="padding: 0 8px">同比上年</td>` : ''}
                <td style="padding: 0 8px">占比</td>
                <td style="padding: 0 8px">成本</td>
              </tr>

              ${params
                .map((item: any) => {
                  if (item.data[1]) {
                    const ratioValue = item.data?.[2]?.ratio !== undefined ? item.data?.[2]?.ratio : null;
                    const ratioDisplay = ratioValue !== null ? `${ratioValue}%` : '-';
                    return `
                  <tr style="text-align: right;">
                    <td style="padding: 0 8px;text-align: left;">
                    ${item.marker}${item.data?.[2]?.isPeriod ? datas.dataQueryPeriodName : ''}总用能：</td>
                    <td style="padding: 0 8px;color: ${
                      theme === Themes.DARK ? 'rgba(255,255,255,0.85)' : 'rgba(0,0,0,0.85)'
                    }">${formatNumber(item.data[1])}${unit}</td>
                    <td style="padding: 0 8px;color: ${params[0].color}">${TrendIndicator(item?.data?.[2]?.mom)}</td>
                    ${isShowYoy ? `<td style="padding: 0 8px;">${TrendIndicator(item?.data?.[2]?.yoy)}</td>` : ''}
                    <td style="padding: 0 8px;">${item.data?.[2]?.isPeriod ? '-' : ratioDisplay}</td>
                    <td style="padding: 0 8px">${
                      item.data?.[2]?.isPeriod ? '-- ' : keepTwoOrLine(cost?.data?.[1])
                    }元</td>
                  </tr>

              `;
                  }
                })
                .join('')}
          </table>
          </div>
        `;

        tooltipHtml += ` <div style="font-size:12px;">
              <table>
               <tr style="text-align: right;">
                <td style="padding: 0 8px; text-align: left">
                ${dayjs(Number(params[0]?.axisValue)).format(
                  timeResolution === DateType.DAY ? 'YYYY-MM-DD HH:mm' : xLabel(timeResolution)
                )}</td>
                <td style="padding: 0 8px">用能</td>
                <td style="padding: 0 8px">${momTitleFunc(timeResolution as DateType)}</td>
                ${isShowYoy ? `<td style="padding: 0 8px">同比上年</td>` : ''}
                <td style="padding: 0 8px">占比</td>
                <td style="padding: 0 8px">成本</td>
              </tr>

              <tr style="text-align: right;">
                <td style="padding: 0 8px 0 24px;text-align: left">总用能</td>
                <td style="padding: 0 8px;text-align: right;">
                  ${formatNumber(item?.value)}${unit}
                </td>
                <td style="padding: 0 8px">${TrendIndicator(item?.mom)}</td>
                ${isShowYoy ? `  <td style="padding: 0 8px">${TrendIndicator(item?.yoy)}</td>` : ''}
                <td style="padding: 0 8px">-</td>
                <td style="padding: 0 8px">${keepTwoOrLine(cost?.data?.[1])}元</td>

              </tr>

               ${params
                 .filter((param: any) => !param.data?.[2]?.isPeriod)
                 .map((param: any, index: number) => {
                   const ratioValue = param.data?.[2]?.ratio !== undefined ? param.data?.[2]?.ratio : null;
                   const ratioDisplay = ratioValue !== null ? `${ratioValue}%` : '-';
                   return `
                  <tr style="text-align: right;">
                    <td style="padding: 0 8px;text-align: left;">${param.marker}${param.seriesName}</td>
                    <td style="padding: 0 8px;color: ${
                      theme === Themes.DARK ? 'rgba(255,255,255,0.85)' : 'rgba(0,0,0,0.85)'
                    }">${formatNumber(param?.data?.[1])}${unit}</td>
                    <td style="padding: 0 8px">${TrendIndicator(param.data?.[2]?.mom)}</td>
                    ${isShowYoy ? `<td style="padding: 0 8px;">${TrendIndicator(param?.data?.[2]?.yoy)}</td>` : ''}
                    <td style="padding: 0 8px;">${ratioDisplay}</td>
                    <td style="padding: 0 8px">--元</td>
                  </tr>
                      `;
                 })
                 .join('')}
                 ${
                   params.find((param: any) => param.data?.[2]?.isPeriod)
                     ? `<tr style="height:1px; background: rgba(255,255,255,0.2);margin: 6px 0">
                    <td style="padding: 0 8px 0 24px;text-align: left"></td>
                    <td style="padding: 0 8px;color: #FFCB47;"></td>
                    <td style="padding: 0 8px;"></td>
                    ${isShowYoy ? `<td style="padding: 0 8px;"></td>` : ''}
                    <td style="padding: 0 8px;"></td>
                    <td style="padding: 0 8px"></td>
                  </tr>


                  <tr style="text-align: right;">
                  <td style="padding: 0 8px 0 24px;text-align: left">${datas.dataQueryPeriodName}-总用能</td>
                  <td style="padding: 0 8px;color: ${
                    theme === Themes.DARK ? 'rgba(255,255,255,0.85)' : 'rgba(0,0,0,0.85)'
                  }">${formatNumber(periodItem?.value)}${unit}</td>
                  <td style="padding: 0 8px;">${TrendIndicator(periodItem?.mom)} </td>
                ${isShowYoy ? `<td style="padding: 0 8px;">${TrendIndicator(periodItem?.yoy)}</td>` : ''}
                <td style="padding: 0 8px;">-</td>
                <td style="padding: 0 8px">--元</td>
                </tr>
                  `
                     : ''
                 }

                 ${params
                   .filter((param: any) => param?.data?.[2]?.isPeriod)
                   .map((param: any, index: number) => {
                     const ratioValue = param.data?.[2]?.ratio !== undefined ? param.data?.[2]?.ratio : null;
                     const ratioDisplay = ratioValue !== null ? `${ratioValue}%` : '-';
                     return `
                      <tr style="text-align: right;">
                    <td style="padding: 0 8px;text-align: left;">${param.marker}${param.seriesName}</td>
                    <td style="padding: 0 8px;color: ${
                      theme === Themes.DARK ? 'rgba(255,255,255,0.85)' : 'rgba(0,0,0,0.85)'
                    }">${formatNumber(param?.data?.[1])}${unit}</td>
                    <td style="padding: 0 8px">${TrendIndicator(param.data?.[2]?.mom)}</td>
                    ${isShowYoy ? `<td style="padding: 0 8px;">${TrendIndicator(param?.data?.[2]?.yoy)}</td>` : ''}
                    <td style="padding: 0 8px;">${ratioDisplay}</td>
                    <td style="padding: 0 8px">--元</td>
                  </tr>
                      `;
                   })
                   .join('')}
              </table>
        </div>`;

        toolBubble += `<div style="font-size:12px;">
              <table>
               <tr style="text-align: right;">
                <td style="padding: 0 8px; text-align: left">  
                ${dayjs(Number(params[0]?.axisValue)).format(
                  timeResolution === DateType.DAY ? 'YYYY-MM-DD HH:mm' : xLabel(timeResolution)
                )}</td>
                <td style="padding: 0 8px"></td>
               
              </tr>

              <tr style="text-align: right;">
                <td style="padding: 0 8px;text-align: left;color:${factcolor}">${factData ?? '--'}</td>
                <td style="padding: 0 8px;text-align: right;">
                  ${formatNumber(params[0].data.extra)}${stateEnergyData.generalUnitName}
                </td>
              </tr>
            
              </table>
        </div>`;
        if (timeResolution === DateType.DAY && params[0].seriesType === 'line') {
          return toolBubble;
        } else if (timeResolution === DateType.DAY) {
          return toolHtmlDay;
        } else {
          return tooltipHtml;
        }
      },
    },
    toolbox: {
      width: 86,
      height: 100,
      right: 10,
      itemSize: 20, // 设置图标大小
      feature: {
        brush: {
          type: ['lineX', 'clear'], // 选择工具类型
          title: {
            lineX: '横向选择',
            clear: '清除',
          },
        },
      },
    },
    brush: {
      toolbox: ['lineX', 'clear'],
      xAxisIndex: 0,
    },
    xAxis: [
      {
        // type: 'category',
        type: 'time',
        axisTick: { alignWithLabel: true },
        minInterval: timeResolution === DateType.DAY ? 60 * 1000 * 30 : 60 * 1000 * 60 * 24,
        // data: xData,
        axisLabel: {
          formatter: (value: number) => dayjs(value).format(xLabel(timeResolution)),
          margin: 8,
          lineHeight: 14,
        },
        // gridIndex: [0, 1],
      },
      // { type: 'time', gridIndex: 1, show: false },
    ],
    yAxis: [
      { type: 'value', name: datas.generalUnitName, nameGap: 8 },
      {
        type: 'value',
        name: '元',
        nameGap: 8,
        splitLine: { show: false },
      },
    ],
    dataZoom: [
      {
        show: true,
        type: 'slider',
        // realtime: true,
        // xAxisIndex: 0,
        // gridIndex: 0,
        labelFormatter: (value: string) => {
          // const time = datas?.totalData?.peakDataList?.[Number(value)]?.time;
          return dayjs(value).format(xLabel(timeResolution));
        },
        bottom: 20,
      },
      // {
      //   type: 'inside',
      //   realtime: true,
      //   gridIndex: 1,
      //   xAxisIndex: 0,
      // },
    ],
    series: [
      {
        type: 'line',
        markLine: {
          silent: true,
          symbol: ['none', 'none'],
          data: [
            {
              label: {
                formatter: (params: any) => `平均值: ${params.value.toFixed(1)}${unit}`,
                position: 'insideEndTop',
                color: theme === Themes.DARK ? '#59D744' : '#61C350',
              },
              yAxis: datas.totalData?.avg ?? 0,
              lineStyle: {
                type: 'dashed',
                width: 2,
                color: theme === Themes.DARK ? '#59D744' : '#61C350',
              },
            },
          ],
        },
        ...(timeResolution === DateType.DAY && {
          markPoint: getCommonMarkPint(
            statsC.maxValue,
            statsC.maxIndex,
            statsC.minValue,
            statsC.minIndex,
            datas.generalUnitName
          ),
          markArea: {
            silent: true,
            data: ePriceTimes ? getMarkAreaData(ePriceTimes, datas) : [],
          },
        }),
      },
      {
        name: '尖时段',
        type: 'bar',
        stack: '总成本',
        barMaxWidth: 80,
        data: datas.totalData?.summitDataList?.map(a => [a.time, a.value, { mom: a.mom, yoy: a.yoy, ratio: a.ratio }]),
        itemStyle: { color: '#FF6D2C' },
        tooltip: { show: true, tooltipIndex: 0 },
      },
      {
        name: '峰时段',
        type: 'bar',
        stack: '总成本',
        data: datas.totalData?.peakDataList?.map(a => [a.time, a.value, { mom: a.mom, yoy: a.yoy, ratio: a.ratio }]),
        itemStyle: { color: '#CE90D1' },
        tooltip: { show: true, tooltipIndex: 0 },
      },
      {
        name: '平时段',
        type: 'bar',
        stack: '总成本',
        data: datas.totalData?.plainDataList?.map(a => [a.time, a.value, { mom: a.mom, yoy: a.yoy, ratio: a.ratio }]),
        itemStyle: { color: '#0DB6D9' },
        tooltip: { show: true, tooltipIndex: 0 },
      },
      {
        name: '谷时段',
        type: 'bar',
        stack: '总成本',
        data: datas.totalData?.valleyDataList?.map(a => [a.time, a.value, { mom: a.mom, yoy: a.yoy, ratio: a.ratio }]),
        itemStyle: { color: '#63BC7F' },
        ...(timeResolution !== DateType.DAY && {
          markPoint: getCommonMarkPint(statsA.maxValue, statsA.maxValueTime, statsA.minValue, statsA.minValueTime),
        }),
        tooltip: { show: true, tooltipIndex: 0 },
      },
      ...(datas.dataQueryPeriodId
        ? [
            {
              name: `${datas.dataQueryPeriodName} - 尖时段`,
              type: 'bar',
              barMaxWidth: 80,
              stack: '时段',
              data: datas.periodData?.summitDataList?.map(i => [i.time, i.value, { isPeriod: true, ratio: i.ratio }]),
              itemStyle: { color: 'rgba(255,109,44, 0.5)' },
            },
            {
              name: `${datas.dataQueryPeriodName} - 峰时段`,
              type: 'bar',
              stack: '时段',
              data: datas.periodData?.peakDataList?.map(i => [i.time, i.value, { isPeriod: true, ratio: i.ratio }]),
              itemStyle: { color: 'rgba(206,144,209, 0.5)' },
            },
            {
              name: `${datas.dataQueryPeriodName} - 平时段`,
              type: 'bar',
              stack: '时段',
              data: datas.periodData?.plainDataList?.map(i => [i.time, i.value, { isPeriod: true, ratio: i.ratio }]),
              itemStyle: { color: 'rgba(13,182,217,0.5)' },
            },
            {
              name: `${datas.dataQueryPeriodName} - 谷时段`,
              type: 'bar',
              stack: '时段',
              data: datas.periodData?.valleyDataList?.map(i => [i.time, i.value, { isPeriod: true, ratio: i.ratio }]),
              itemStyle: { color: 'rgba(99,188,127, 0.5)' },
            },
          ]
        : []),
      ...(timeResolution === DateType.DAY
        ? [
            {
              type: 'custom',
              // name: '状态条',
              // xAxisIndex: 0,
              // yAxisIndex: 1,
              // gridIndex: 1,
              renderItem: (params: any, api: any) => {
                const start = api.coord([api.value(0), 0]);
                const end = api.coord([api.value(1), 0]);
                const height = 20;

                const statusValue = api.value(2) as WorkStatusType | null;

                return {
                  type: 'rect',
                  shape: {
                    x: start[0],
                    y: start[1] - height / 2 + 50,
                    width: end[0] - start[0],
                    height: height,
                  },
                  style: { fill: statusValue ? statusMap[statusValue].color : '#232324' },
                };
              },
              encode: { x: [0, 1] },
              data: bubbleData?.map(b => [b.startTime, b.endTime, b.type, b.energyDetail?.totalValue]),
              tooltip: {
                show: true,
                trigger: 'item',
                formatter: (p: any) => {
                  const data = p.data;
                  if (!data[2]) return;
                  const { name, color } = statusMap[data[2] as WorkStatusType];

                  return `
                  <div>
                    <div>${dayjs(data[0]).format('MM-DD HH:mm')} ~ ${dayjs(data[1]).format('MM-DD HH:mm:ss')}</div>
                    <div style='display:flex;justify-content:space-between'><span style='color:${color}'>${name}</span>${keepTwoOrLine(
                    data[3]
                  )}${datas.generalUnitName}</div>
                  </div>
                  `;
                },
              },
            },
          ]
        : []),
      {
        name: '总用能成本',
        type: 'line',
        yAxisIndex: 1,
        data: datas.totalData?.totalDataList?.map(a => [a.time, a.cost]),
        itemStyle: { color: '#FFCB47' },
        lineStyle: { width: 2 },
        symbol: 'circle',
        symbolSize: 6,
      },
    ],
  };
};

export const totalOption = (
  datas: DataProps,
  stateEnergyData: StateEnergyProps,
  timeResolution: string,
  nameValue: string,
  theme: Themes
) => {
  const makeSeries = (data: any[], name?: string) => ({
    name: name + nameValue,
    data: data?.map(i => [i.time, i.value, { mom: i.mom, yoy: i.yoy }]),
    type: 'bar',
    markLine: {
      symbol: ['none', 'none'],
      label: {
        show: true,
        color: '#63BC7F',
        position: 'insideEndTop',
        formatter: (params: any) => `平均值: ${params.value.toFixed(1)}${datas.generalUnitName}`,
      },
      lineStyle: {
        color: '#63BC7F',
        type: 'dashed',
        width: 2,
      },
      yAxis: datas.totalData?.avg ?? 0,
    },
    markPoint: getCommonMarkPint(),
  });
  const isShowYoy = timeResolution === DateType.WEEK || timeResolution === DateType.MONTH;
  // const xData = datas?.totalData?.totalDataList?.map(i => i.time) || [];
  const bubbleData = stateEnergyData.bubble;
  return {
    grid: [
      {
        left: 40,
        right: 10,
        top: 70,
        containLabel: true,
        height: timeResolution === DateType.DAY ? '65%' : '75%',
      },
    ],
    legend: [
      {
        top: 5,
        right: 170,
        icon: 'rect',
        itemWidth: 12,
        itemHeight: 12,
        data: [nameValue, `${datas.dataQueryPeriodName}-${nameValue}`],
      },
      {
        right: 80,
        top: 5,
        icon: 'rect',
        itemWidth: 12,
        itemHeight: 4,
        data: [{ name: '总用能成本' }],
      },
    ],

    dataZoom: [
      {
        show: true,
        type: 'slider',
        labelFormatter: (value: string) => {
          return dayjs(value).format(xLabel(timeResolution));
        },
      },
    ],
    xAxis: [
      {
        type: 'time',
        axisTick: { alignWithLabel: true },
        minInterval: timeResolution === DateType.DAY ? 60 * 1000 * 30 : 60 * 1000 * 60 * 24,
        axisLabel: {
          formatter: (value: number) => dayjs(Number(value)).format(xLabel(timeResolution)),
          margin: 8,
          lineHeight: 14,
        },
      },
    ],
    yAxis: [
      { type: 'value' },
      {
        type: 'value',
        name: '元',
        nameGap: 8,
        splitLine: { show: false },
      },
    ],
    toolbox: {
      width: 86,
      height: 100,
      right: 10,
      itemSize: 20, // 设置图标大小
      feature: {
        brush: {
          type: ['lineX', 'clear'], // 选择工具类型
          title: {
            lineX: '横向选择',
            clear: '清除',
          },
        },
      },
    },
    brush: {
      toolbox: ['lineX', 'clear'],
      xAxisIndex: 0,
    },
    color: ['var(--mx-diagram1-color)', 'var(--mx-diagram3-color)', '#007bff'],
    tooltip: {
      formatter: (originParams: any) => {
        const cost = originParams.find((item: any) => item.seriesName === '总用能成本');
        const tooltipData = originParams.filter((item: any) => item.seriesName !== '总用能成本');
        let toolHtmlDay = ``;
        let toolBubble = ``;
        const factData = WorkStatusDisplay[tooltipData[0].data.value as WorkStatusType];
        const factcolor =
          tooltipData[0].data.value === WorkStatusType.SHUT
            ? 'rgba(255,77,79,0.8)'
            : tooltipData[0].data.value === WorkStatusType.RUN
            ? 'rgba(22,221,142,0.8)'
            : tooltipData[0].data.value === WorkStatusType.STANDBY
            ? 'rgba(250,173,20,0.8)'
            : 'none';

        toolHtmlDay += `
        <div style="font-size:12px;">
          <table>
            <tr style="text-align: right;">
              <td style="padding: 0 8px; text-align: left">  
              ${dayjs(Number(tooltipData[0]?.axisValue)).format(
                timeResolution === DateType.DAY ? 'YYYY-MM-DD HH:mm' : xLabel(timeResolution)
              )}</td>
              <td style="padding: 0 8px">用能</td>
              <td style="padding: 0 8px">${momTitleFunc(timeResolution as DateType)}</td>
              ${isShowYoy ? `<td style="padding: 0 8px">同比上年</td>` : ''}
              <td style="padding: 0 8px">成本</td>
            </tr>

             ${tooltipData
               .map((param: any, index: number) => {
                 return `
                  <tr style="text-align: right;">
                    <td style="padding: 0 8px;text-align: left;">${param.marker}${param.seriesName}</td>
                    <td style="padding: 0 8px;color: ${
                      theme === Themes.DARK ? 'rgba(255,255,255,0.85)' : 'rgba(0,0,0,0.85)'
                    }">${formatNumber(param?.data[1])}${datas.generalUnitName}</td>
                    <td style="padding: 0 8px">${TrendIndicator(param?.data[2]?.mom)}</td>
                    ${isShowYoy ? `<td style="padding: 0 8px;">${TrendIndicator(param?.data[2]?.yoy)}</td>` : ''}
                    <td style="padding: 0 8px">${index === 0 ? keepTwoOrLine(cost.data[1]) : '--'}元</td>
                  </tr>
                      `;
               })
               .join('')}
          </table>
        </div>
          `;

        toolBubble += `<div style="font-size:12px;">
              <table>
               <tr style="text-align: right;">
                <td style="padding: 0 8px; text-align: left">  
                ${dayjs(Number(tooltipData[0]?.axisValue)).format(
                  timeResolution === DateType.DAY ? 'YYYY-MM-DD HH:mm' : xLabel(timeResolution)
                )}</td>
                <td style="padding: 0 8px"></td>
               
              </tr>

              <tr style="text-align: right;">
                <td style="padding: 0 8px;text-align: left;color:${factcolor}">${factData ?? '--'}</td>
                <td style="padding: 0 8px;text-align: right;">
                  ${formatNumber(tooltipData[0].data.extra)}${stateEnergyData.generalUnitName}
                </td>
              </tr>
            
              </table>
        </div>`;
        if (tooltipData[0].seriesType === 'line') {
          return toolBubble;
        } else {
          return toolHtmlDay;
        }
      },
    },
    series: [
      makeSeries(datas?.totalData?.totalDataList ?? [], ''),
      ...(datas.dataQueryPeriodName
        ? [makeSeries(datas?.periodData?.totalDataList ?? [], `${datas.dataQueryPeriodName}`)]
        : []),
      ...(timeResolution === DateType.DAY
        ? [
            {
              type: 'custom',
              // name: '状态条',
              // xAxisIndex: 1,
              // yAxisIndex: 1,
              renderItem: (params: any, api: any) => {
                const start = api.coord([api.value(0), 0]);
                const end = api.coord([api.value(1), 0]);
                const height = 20;
                const statusValue = api.value(2) as WorkStatusType | null;

                return {
                  type: 'rect',
                  shape: {
                    x: start[0],
                    y: start[1] - height / 2 + 50,
                    width: end[0] - start[0],
                    height: height,
                  },
                  style: { fill: statusValue ? statusMap[statusValue].color : '#232324' },
                };
              },
              encode: { x: [0, 1] },
              data: bubbleData?.map(b => [b.startTime, b.endTime, b.type, b.energyDetail?.totalValue]),
              tooltip: {
                show: true,
                trigger: 'item',
                formatter: (p: any) => {
                  const data = p.data;
                  if (!data[2]) return;
                  const { name, color } = statusMap[data[2] as WorkStatusType];

                  return `
                  <div>
                    <div>${dayjs(data[0]).format('MM-DD HH:mm')} ~ ${dayjs(data[1]).format('MM-DD HH:mm:ss')}</div>
                    <div style='display:flex;justify-content:space-between'><span style='color:${color}'>${name}</span>${keepTwoOrLine(
                    data[3]
                  )}${datas.generalUnitName}</div>
                  </div>
                  `;
                },
              },
            },
          ]
        : []),
      {
        name: '总用能成本',
        type: 'line',
        yAxisIndex: 1,
        data: datas.totalData?.totalDataList?.map(a => [a.time, a.cost]),
        itemStyle: { color: '#FFCB47' },
        lineStyle: { width: 2 },
        symbol: 'circle',
        symbolSize: 6,
      },
    ],
  };
};

const getCommonMarkPint = (
  maxValue?: number,
  maxValueTime?: number,
  minValue?: number,
  minValueTime?: number,
  unit?: string,
  name?: string
) => {
  const getSafeIcon = (index: number) => {
    if (!icons || !Array.isArray(icons) || index >= icons.length) {
      return 'circle'; // 默认为圆形符号
    }
    return `image://${icons[index]}`;
  };

  // 安全格式化数值，处理自动计算时的场景
  const formatValue = (value: any) => {
    if (value === null || value === undefined) return '0.00';
    return typeof value === 'number' ? value.toFixed(2) : String(value);
  };

  // 构建最大值标记点配置
  const maxPointConfig: any = {
    type: 'max',
    name: '最高',
    symbol: getSafeIcon(3),
    itemStyle: {
      color: '#FF0000',
    },
    label: {
      formatter: function (data: any) {
        console.log('data', data, unit);
        return `最大值：${formatValue(data.value)}${unit ?? ''}`;
      },
      color: '#FFFFFF',
    },
  };

  // 只有当同时提供maxValue和maxIndex时才手动指定位置
  if (maxValue !== undefined && maxValueTime !== undefined) {
    maxPointConfig.value = maxValue;
    maxPointConfig.coord = [maxValueTime, maxValue];
  }

  const minPointConfig: any = {
    type: 'min',
    name: '最低',
    symbol: getSafeIcon(4),
    itemStyle: {
      color: '#00ADFF',
    },
    label: {
      formatter: function (data: any) {
        return `最小值：${formatValue(data.value)}${unit ?? ''}`;
      },
      color: '#FFFFFF',
    },
  };
  // 只有当同时提供minValue和minIndex时才手动指定位置

  if (minValue !== undefined && minValueTime !== undefined) {
    minPointConfig.value = minValue;
    minPointConfig.coord = [minValueTime, minValue];
  }

  return {
    label: {
      show: true,
      offset: [0, -4],
    },
    emphasis: {
      show: true,
      offset: [0, -4],
    },
    symbolSize: [name ? 160 : 120, 26],
    symbolOffset: [0, -13],
    data: [maxPointConfig, minPointConfig],
    itemStyle: {
      normal: {
        color: '#d6a223',
      },
    },
  };
};

export const TrendIndicator = (value: number | undefined) => {
  if (!value) return `--`;
  const currentValue = value ?? 0;
  const isUp = currentValue > 0;
  const displayValue = isUp ? currentValue : Math.abs(currentValue);

  return `<span style="color: ${isUp ? '#F87272' : '#36D399'}">
               ${isUp ? '+' : '-'}${(displayValue * 100).toFixed(2)}%
            </span>
          `;
};
const PERIOD_CONFIG: { key: PeriodKey; label: string }[] = [
  { key: 'summitDataList', label: '尖时段用能' },
  { key: 'peakDataList', label: '峰时段用能' },
  { key: 'plainDataList', label: '平时段用能' },
  { key: 'valleyDataList', label: '谷时段用能' },
];
// 统计函数：返回 max/min/index/avg
export const getStats = (data: any, config = PERIOD_CONFIG) => {
  const categoriesCount = data?.summitDataList?.length || 0;
  const allSeriesData = config.map(cfg => data?.[cfg.key]?.map((i: any) => i.value) || []);

  const totalValues = Array.from({ length: categoriesCount }, (_, idx) =>
    allSeriesData.reduce((sum, series) => sum + (series[idx] || 0), 0)
  );
  const maxValue = Math.max(...totalValues);

  const nonZeroValues = totalValues.filter(value => value !== 0);
  let minValue = Math.min(...nonZeroValues);
  if (nonZeroValues.length === 1) {
    minValue = Math.min(...totalValues);
  } else {
    minValue = Math.min(...nonZeroValues);
  }

  const maxIndex = totalValues.indexOf(maxValue);
  const minIndex = totalValues.indexOf(minValue);
  return {
    maxValue,
    minValue: minValue,
    maxValueTime: data?.summitDataList?.find((_: any, index: number) => index === maxIndex)?.time,
    minValueTime: data?.summitDataList?.find((_: any, index: number) => index === minIndex)?.time,
    avgValue: totalValues.length ? totalValues.reduce((sum, v) => sum + v, 0) / totalValues.length : 0,
  };
};

export const getUnstackedStats = (data: any, config = PERIOD_CONFIG) => {
  const safeData = typeof data === 'object' && data !== null ? data : {};
  const allItems = config.flatMap(cfg => {
    // 获取当前key对应的数据集（默认空数组）
    const items = safeData[cfg.key];
    return Array.isArray(items) ? items : [];
  });

  const timeUniqueMap = allItems.reduce((acc, item) => {
    const { time, value } = item;

    const existingItem = acc[time];

    if (existingItem) {
      // 若time已存在，仅当新value有值时才覆盖
      if (value !== null && value !== undefined) {
        acc[time] = { time, value };
      }
    } else {
      // 若time不存在，直接添加（无论value是否有值）
      acc[time] = { time, value };
    }

    return acc;
  }, {} as Record<number, { time: number; value: number | null | undefined }>);

  const resData = Object.values(timeUniqueMap);
  let sum = 0;
  // 初始化最大/最小值及对应索引
  const totalCount = resData.length;
  let maxValue = -Infinity;
  let maxIndex = -1;
  let minValue = Infinity;
  let minIndex = -1;

  // // 遍历数组查找
  resData.forEach((item: any, index) => {
    const currentValue = item.value ?? 0;
    sum += currentValue;
    // 找最大值
    if (item.value > maxValue) {
      maxValue = item.value;
      maxIndex = item.time;
    }
    if (currentValue > 0 && item.value < minValue) {
      minValue = item.value;
      minIndex = item.time;
    }
  });

  const avgValue = totalCount > 0 ? sum / totalCount : 0;
  return {
    maxValue,
    minValue,
    maxIndex, // 用于 markPoint xAxis
    minIndex,
    avgValue,
  };
};
